import { capitalizeEachWords } from "../../../../utils/helpers";

export const transformBrandConfigData = (
  brandConfigurationReportList: any[],
) => {
  if (!brandConfigurationReportList) return [];

  return brandConfigurationReportList.map((item: any) => {
    const baseTransform = {
      ...item,
      brand:
        item.brands__name && item.brand_id
          ? `${item.brands__name} (${item.brand_id})`
          : item.brands__name || item.brand_id || "",
    };

    // Handle null/undefined/empty integration_status
    if (
      item.integration_status === null ||
      item.integration_status === undefined ||
      item.integration_status === ""
    ) {
      return {
        ...baseTransform,
        integration_status: "Not Ready",
        additional_information: {
          ...item.additional_information,
          step: "Properties",
          reason: "Missing mandatory fields",
        },
      };
    }

    // new requirements ((https://optival.atlassian.net/browse/GR-20919))
    // Ready / Running / Pending → no step and reason column should be empty
    if (
      item.integration_status === "Ready" ||
      item.integration_status === "Running" ||
      item.integration_status === "Pending"
    ) {
      return {
        ...baseTransform,
        additional_information: {
          ...item.additional_information,
          step: "",
          reason: "",
        },
      };
    }

    return baseTransform;
  });
};

// export const transformBrandConfigData = (
//   brandConfigurationReportList: any[],
// ) => {
//   if (!brandConfigurationReportList) return [];

//   return brandConfigurationReportList.map((item: any) => {
//     const baseTransform = {
//       ...item,
//       brand:
//         item.brands__name && item.brand_id
//           ? `${item.brands__name} (${item.brand_id})`
//           : item.brands__name || item.brand_id || "",
//     };

//     // "Stuck_at" (step) is only meaningful for "Not Ready" — it shows where
//     // the brand got stuck. For Ready / Running / Pending / Null it stays empty.
//     // `reason` is left untouched — it always comes from the API response.
//     if (item.integration_status === "Not Ready") {
//       return baseTransform;
//     }

//     // Every other status like Ready, Running, Pending, Null step should be empty (https://optival.atlassian.net/browse/GR-20919)
//     return {
//       ...baseTransform,
//       additional_information: {
//         ...item.additional_information,
//         step: "",
//         reason: "",
//       },
//     };
//   });
// };

export const filterBrandConfigRows = (
  rows: any[],
  filters: {
    selectedBrandName?: string;
    selectedIntegrationStatus?: any[];
    selectedStuckAt?: any[];
    selectedReason?: any[];
    selectedAffiliatedSystem?: any[];
    selectedWebsite?: any[];
    selectedLastRun?: any[];
  },
) => {
  const {
    selectedBrandName,
    selectedIntegrationStatus = [],
    selectedStuckAt = [],
    selectedReason = [],
    selectedAffiliatedSystem = [],
    selectedWebsite = [],
    selectedLastRun = [],
  } = filters;

  return (rows || []).filter((row: any) => {
    const brandNameMatch = selectedBrandName
      ? row.brand
          ?.toLowerCase()
          .trim()
          .includes(selectedBrandName.toLowerCase().trim())
      : true;

    const integrationStatusMatch =
      selectedIntegrationStatus.length > 0
        ? selectedIntegrationStatus.includes(row.integration_status)
        : true;

    const stuckAtMatch =
      selectedStuckAt.length > 0
        ? selectedStuckAt.includes(
            row.additional_information?.step
              ? capitalizeEachWords(row.additional_information.step)
              : "",
          )
        : true;

    const reasonMatch =
      selectedReason.length > 0
        ? selectedReason.includes(row.additional_information?.reason)
        : true;

    const affiliatedSystemMatch =
      selectedAffiliatedSystem.length > 0
        ? selectedAffiliatedSystem.includes(row.backend_interface_name)
        : true;

    const websiteMatch =
      selectedWebsite.length > 0
        ? selectedWebsite.includes(row.ui_site_name)
        : true;

    const lastRunMatch =
      selectedLastRun &&
      selectedLastRun.length === 2 &&
      selectedLastRun[0] &&
      selectedLastRun[1]
        ? selectedLastRun[0] === selectedLastRun[1]
          ? new Date(row.additional_information?.last_run).toDateString() ===
            new Date(selectedLastRun[0]).toDateString()
          : new Date(row.additional_information?.last_run) >=
              new Date(selectedLastRun[0]) &&
            new Date(row.additional_information?.last_run) <=
              new Date(new Date(selectedLastRun[1]).setHours(23, 59, 59, 999))
        : true;

    return (
      brandNameMatch &&
      integrationStatusMatch &&
      stuckAtMatch &&
      reasonMatch &&
      affiliatedSystemMatch &&
      websiteMatch &&
      lastRunMatch
    );
  });
};
